import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, WorldCupReportData, WorldCupReportListData } from './types';

const initialState: initState = {
  participationsReport: {
    filename: '',
    message: '',
  },
  prizesReport: {
    filename: '',
    message: '',
  },
  prizeDrawsReport: {
    filename: '',
    message: '',
  },
  reportList: {
    count: 0,
    rows: [],
  },
};

const worldCupReportsSlice = createSlice({
  name: 'worldCupReports',
  initialState,
  reducers: {
    setParticipationsReportData(state: initState, action: PayloadAction<{ participationsReport: WorldCupReportData }>) {
      state.participationsReport = action.payload.participationsReport;
    },
    setPrizesReportData(state: initState, action: PayloadAction<{ prizesReport: WorldCupReportData }>) {
      state.prizesReport = action.payload.prizesReport;
    },
    setPrizeDrawsReportData(state: initState, action: PayloadAction<{ prizeDrawsReport: WorldCupReportData }>) {
      state.prizeDrawsReport = action.payload.prizeDrawsReport;
    },
    setWorldCupReportListData(state: initState, action: PayloadAction<{ reportList: WorldCupReportListData }>) {
      state.reportList = action.payload.reportList;
    },
  },
});

export const {
  setParticipationsReportData,
  setPrizesReportData,
  setPrizeDrawsReportData,
  setWorldCupReportListData,
} = worldCupReportsSlice.actions;

export default worldCupReportsSlice.reducer;
